module.exports = __webpack_public_path__ + "d1ff61f0.jpg";